export const CONNECTOR_ICONS: Record<string, string> = {
  wrike: "✅",
  sharepoint: "🔵",
  asana: "📋",
  figma: "🎨",
  google_drive: "📁",
  canva: "🖼️",
  "microsoft-teams": "💬",
};
